import { defineMessages } from 'react-intl';

export const profileMessages = defineMessages({
    title: {
        id: 'profile-my-profile',
        defaultMessage: 'My profile',
    },
    details: {
        id: 'profile-details',
        defaultMessage: 'Details',
    },
    email: {
        id: 'profile-email',
        defaultMessage: 'Email',
    },
    password: {
        id: 'profile-password',
        defaultMessage: 'Password',
    },
    settings: {
        id: 'profile-settings',
        defaultMessage: 'Settings',
    },
    notifications: {
        id: 'profile-notifications',
        defaultMessage: 'Notifications',
    },
});

export const detailsMessages = defineMessages({
    personalInfoTitle: {
        id: 'profile-details-personal-info',
        defaultMessage: 'Personal Info',
    },
    personalInfoSubtitle: {
        id: 'profile-details-personal-info-subtitle',
        defaultMessage: 'Update your photo and personal details here',
    },
    name: {
        id: 'profile-details-personal-info-name',
        defaultMessage: 'Name',
    },
    nameSubtitle: {
        id: 'profile-details-personal-info-names-subtitle',
        defaultMessage: 'Your first and last name, used for identifying you across SmartPark',
    },
    picture: {
        id: 'profile-details-personal-info-picture',
        defaultMessage: 'Profile picture',
    },
    pictureSubtitle: {
        id: 'profile-details-personal-info-picture-subtitle',
        defaultMessage:
            'The picture displayed as your avatar right by your name, used for identifying you across SmartPark',
    },
    pictureUpload: {
        id: 'profile-details-personal-info-picture-upload',
        defaultMessage: '<link>Click to upload</link> or drag and drop',
    },
    pictureUploadFileTypes: {
        id: 'profile-details-personal-info-picture-file-types',
        defaultMessage: 'PNG or JPG (max. 1MB)',
    },
    nameChange: {
        id: 'profile-details-personal-info-name-change',
        defaultMessage: 'Change name',
    },
    nameChangeSubtitle: {
        id: 'profile-details-personal-info-name-change-subtitle',
        defaultMessage: 'Change your personal information',
    },
    nameChangeSuccess: {
        id: 'profile-details-personal-info-name-change-success',
        defaultMessage: 'Name changed',
    },
    nameChangeSuccessDetails: {
        id: 'profile-details-personal-info-name-change-success-details',
        defaultMessage: 'Name successfully changed to: {name}',
    },
    nameChangeDialog: {
        id: 'profile-details-personal-info-name-change-dialog',
        defaultMessage: 'Are you sure you want to change your name to {name}?',
    },
    accountInfo: {
        id: 'profile-details-personal-info-account-info',
        defaultMessage: 'Account Info',
    },
    accountInfoSubtitle: {
        id: 'profile-details-personal-info-account-info-subtitle',
        defaultMessage: 'Logout from your account and manage your login sessions',
    },
    logout: {
        id: 'profile-details-personal-info-logout',
        defaultMessage: 'Logout',
    },
});

export const emailMessages = defineMessages({
    emailTitle: {
        id: 'profile-email',
        defaultMessage: 'Email',
    },
    emailTitleSubtitle: {
        id: 'profile-email-subtitle',
        defaultMessage: 'Change the email you use for logging into the system',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    emailSubtitle: {
        id: 'profile-email-email-subtitle',
        defaultMessage:
            'Change the email that you use for logging in to the system, as well for all communications related to SmartPark',
    },
    emailChangeSuccess: {
        id: 'profile-email-email-change-success',
        defaultMessage: 'Email changed',
    },
    emailChangeSuccessDetails: {
        id: 'profile-email-email-change-success-details',
        defaultMessage: 'Email successfully changed to: {email}',
    },
});

export const settingsMessages = defineMessages({
    settingsTitle: {
        id: 'profile-settings',
        defaultMessage: 'Settings',
    },
    settingsSubtitle: {
        id: 'profile-settings-subtitle',
        defaultMessage: 'Change the settings of your account',
    },
    language: {
        id: 'profile-settings-language',
        defaultMessage: 'Language',
    },
    languageSubtitle: {
        id: 'profile-settings-language-subtitle',
        defaultMessage: 'Change the language of the system',
    },
    languageChangeSuccess: {
        id: 'profile-settings-language-change-success',
        defaultMessage: 'Language changed',
    },
    languageChangeSuccessDetails: {
        id: 'profile-settings-language-change-success-details',
        defaultMessage: 'Language successfully changed to: {lang}',
    },
    changeLanguagePlacholder: {
        id: 'profile-settings-change-language-placeholder',
        defaultMessage: 'Select language',
    },
});

export const passwordMessages = defineMessages({
    passwordTitle: {
        id: 'profile-password',
        defaultMessage: 'Password',
    },
    passwordSubtitle: {
        id: 'profile-password-subtitle',
        defaultMessage: 'Change the password used for logging into the system',
    },
    oldPassword: {
        id: 'profile-password-old-password',
        defaultMessage: 'Old password',
    },
    oldPasswordSubtitle: {
        id: 'profile-password-old-password-subtitle',
        defaultMessage: 'The password that you currently use for logging in',
    },
    newPassword: {
        id: 'profile-password-new-password',
        defaultMessage: 'New password',
    },
    newPasswordSubtitle: {
        id: 'profile-password-new-password-subtitle',
        defaultMessage:
            'Your new password, that you are going to use for logging in from now on. The password must be at least 8 characters long, contain letters and numbers, not be similar to the username or email, and not be commonly used.',
    },
    confirmNewPassword: {
        id: 'profile-password-confirm-new-password',
        defaultMessage: 'Confirm new password',
    },
    confirmNewPasswordSubtitle: {
        id: 'profile-password-confirm-new-password-subtitle',
        defaultMessage: 'Confirm your new password',
    },
    passwordChangeSuccess: {
        id: 'profile-password-change-success',
        defaultMessage: 'Password changed',
    },
    passwordChangeSuccessDetails: {
        id: 'profile-password-change-success-details',
        defaultMessage: 'Password successfully changed',
    },
    oldPasswordError: {
        id: 'custom-error:invalid_old_password',
        defaultMessage: 'Old password is incorrect!',
    },
    missingOldPasswordError: {
        id: 'custom-error:missing_old_password',
        defaultMessage: 'Old password is required to change the password!',
    },
    passwordSimilarError: {
        id: 'custom-error:password_too_similar',
        defaultMessage: 'The password is too similar to the username, first name, last name, email.',
    },
    passwordCommonError: {
        id: 'custom-error:password_too_common',
        defaultMessage: 'This password is too common.',
    },
    passwordShortError: {
        id: 'custom-error:password_too_short',
        defaultMessage: 'This password is too short. It must contain at least 8 characters.',
    },
    passwordEntirelyNumericError: {
        id: 'custom-error:password_entirely_numeric',
        defaultMessage: 'This password is entirely numeric.',
    },
    passwordBlankError: {
        id: 'custom-error:blank',
        defaultMessage: 'This field may not be blank.',
    },
});

export const validationMessages = defineMessages({
    personalInfo: {
        id: 'profile-details-personal-info',
        defaultMessage: 'Personal Info',
    },
    personalInfoSubtitle: {
        id: 'profile-details-personal-info-subtitle',
        defaultMessage: 'Update your photo and personal details here',
    },
    name: {
        id: 'profile-details-personal-info-name',
        defaultMessage: 'Name',
    },
    nameSubtitle: {
        id: 'profile-details-personal-info-name-subtitle',
        defaultMessage: 'Your name, used for identifying you across SmartPark',
    },
});
